import {API, BASE_URL} from './config';

export default {
    getAllCenter: async ()=>{
        try {
            const response = await API.get(`${BASE_URL}/webapi/center/centers`);
            // console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    createCenter: async(reqBody)=>{
        try {
            const response = await API.post(`${BASE_URL}/webapi/center/create`,reqBody);
            return response;
        } catch (error) {
            console.log('err', error)
            return error.response;
        }
    },

    deleteCenterById: async(reqBody)=>{
        try {
            const response = await API.post(`${BASE_URL}/webapi/center/delete`,reqBody);
            return response;
        } catch (error) {
            return error.response
        }
    },

    updateCenterById: async(id,reqBody)=>{
        try {
            const response = await API.post(`${BASE_URL}/webapi/center/update/${id}`,reqBody);
            return response;
        } catch (error) {
            console.log("error", error)
            return error.response
        }
    },

    getAllUsersLocation: async ()=>{
        try {
            const response = await API.get(`${BASE_URL}/api/user-location/638850d17f673cad321aa999`);
            console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },
}